import { useTranslation } from 'react-i18next';
import { AlertTriangle, X } from 'lucide-react';
import { useState } from 'react';

/* eslint-disable no-restricted-syntax -- Semantic maintenance warning amber must stay stable across themes */
const BANNER_STYLE = {
  backgroundColor: '#fef3c7',
  color: '#92400e',
  borderBottom: '1px solid #fcd34d'
};
/* eslint-enable no-restricted-syntax */

interface Props {
  isVisible: boolean;
}

/**
 * Maintenance Mode Banner
 * Displays a yellow banner at the top of the page when maintenance mode is active.
 * Only shown to admin users who can still access the system.
 */
export default function MaintenanceBanner({ isVisible }: Props) {
  const { t } = useTranslation();
  const [isDismissed, setIsDismissed] = useState(false);

  if (!isVisible || isDismissed) {
    return null;
  }

  return (
    <div
      className="w-full px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium"
      style={BANNER_STYLE}
    >
      <AlertTriangle className="h-4 w-4 flex-shrink-0" />
      <span>{t('maintenance-mode-active-banner')}</span>
      <button
        onClick={() => setIsDismissed(true)}
        className="ml-2 p-1 rounded-full hover:bg-amber-200 transition-colors"
        aria-label={t('dismiss')}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
